import {Component, Input, OnDestroy, OnInit} from '@angular/core'
import {FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {AnnouncementFormInt} from "../../../interfaces/announcement";
import {AnnouncementService} from "../../../../../../shared/services/announcement.service";
import {DateUtil} from "../../../../date-util";
import {SubmissionSearchUserInfoObject} from "../../../../search-object";
import {SubmissionHistoryService} from "../../../../../../shared/services/submission-history.service";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import * as moment from "moment";


@Component({
    selector: 'baseGroup',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss'],
    providers: [
        AnnouncementService,
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: DateUtil.MY_FORMATS}
    ]
})

export class BaseComp implements OnInit {

    constructor(
        private readonly service: AnnouncementService,
        private readonly fb: FormBuilder,
        private readonly submissionHistoryService: SubmissionHistoryService
    ) {
        this.announcementTypes = ['HEADLINE', 'OUTAGE', 'IMPDATE', 'FEATURE']
    }

    MAT_FORM_FIELD_INVALID = 'mat-form-field-invalid';
    EFFECTIVE_DATE_FORM_FIELD = '#effectiveDateFormField'
    END_DATE_FORM_FIELD = '#endDateFormField';

    userSearchInfo = new SubmissionSearchUserInfoObject();

    minDate = new Date(2000, 0, 1);
    @Input() disabled;
    @Input() edited;
    @Input() form: FormGroup;
    public announcement: FormGroup;
    public announcementTypes: Array<string>;

    protected announcementId: FormControl;
    protected announcementTypeCde: FormControl;
    protected announcementTitle: FormControl;
    protected announcementTxt: FormControl;
    protected effectiveDate: FormControl;
    protected effectiveDateTime: FormControl;
    protected endDate: FormControl;
    protected endDateTime: FormControl;
    protected linkTxt: FormControl;
    protected linkUrl: FormControl;
    protected releaseNumber: FormControl;
    protected reportingCenters: FormControl;

    ngOnInit() {
        this.submissionHistoryService.currentUserInfo.subscribe(message => this.userSearchInfo = message);
        this.form.addControl('announcement', this.announcement);
    }

    @Input() set data(model: AnnouncementFormInt) {
        if (model) {
            const announcement = model.announcement;
            const reportingCenters = model.reportingCenters;

            if (announcement) {
                this.announcementId = new FormControl(announcement.announcementId);
                this.announcementTypeCde = new FormControl({value: announcement.announcementTypeCde, disabled: false}, [Validators.required]);
                this.announcementTitle = new FormControl(announcement.announcementTitle, [Validators.required]);
                this.announcementTxt = new FormControl(announcement.announcementTxt, [Validators.required]);
                this.effectiveDate = new FormControl(DateUtil.formatDateISO(announcement.effectiveDate), [Validators.required, this.startDateGreaterThanEndDate.bind(this)])
                this.endDate = new FormControl(DateUtil.formatDateISO(announcement.endDate), [this.endDateLessThanStartDate.bind(this)]);
                this.effectiveDateTime = new FormControl(announcement.effectiveDateTime)
                this.endDateTime = new FormControl(announcement.endDateTime);
                this.linkTxt = new FormControl(announcement.linkTxt);
                this.linkUrl = new FormControl(announcement.linkUrl);
                this.releaseNumber = new FormControl(announcement.releaseNumber);
                this.reportingCenters = new FormControl(reportingCenters);

                this.announcement = this.fb.group({
                    announcementId: this.announcementId,
                    announcementTypeCde: this.announcementTypeCde,
                    announcementTitle: this.announcementTitle,
                    announcementTxt: this.announcementTxt,
                    effectiveDate: this.effectiveDate,
                    effectiveDateTime: this.effectiveDateTime,
                    endDate: this.endDate,
                    endDateTime: this.endDateTime,
                    linkTxt: this.linkTxt,
                    linkUrl: this.linkUrl,
                    releaseNumber: this.releaseNumber,
                    reportingCenters: this.reportingCenters
                });
            }
        }
    }

    public onStartDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            $(this.EFFECTIVE_DATE_FORM_FIELD).removeClass(this.MAT_FORM_FIELD_INVALID)
        } else {
            $(this.EFFECTIVE_DATE_FORM_FIELD).addClass(this.MAT_FORM_FIELD_INVALID)
        }
    }


    public onEndDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            $(this.END_DATE_FORM_FIELD).removeClass(this.MAT_FORM_FIELD_INVALID)
        } else {
            $(this.END_DATE_FORM_FIELD).addClass(this.MAT_FORM_FIELD_INVALID)
        }
    }

    public onStartDateSelected() {
        $(this.EFFECTIVE_DATE_FORM_FIELD).removeClass(this.MAT_FORM_FIELD_INVALID)
    }

    public onEndDateSelected() {
        $(this.END_DATE_FORM_FIELD).removeClass(this.MAT_FORM_FIELD_INVALID)
    }

    protected startDateGreaterThanEndDate(control: FormControl): { [key: string]: boolean } {
        if (control.value && this.announcement) {
            if (moment(control.value).isAfter(moment(this.endDate.value))) {
                return {greater: true};
            }
        }
        return {};
    }

    protected endDateLessThanStartDate(control: FormControl): { [key: string]: boolean } {
        if (control.value && this.announcement) {
            if (moment(control.value).isBefore(moment(this.effectiveDate.value))) {
                return {less: true};
            }
        }
        return {};
    }
}
